import React, { useState } from "react";
import { Typography, MenuItem, Select } from "@mui/material";
import { MonthYearPickerStyled } from "./month-year-picker.styles"; // New stylesheet
import PropTypes from "prop-types";
import InfoIcon from "../../info-icon/info-icon";

const MonthPickerField = (props) => {
  const {
    value,
    onChange,
    name,
    label,
    placeholder = "Select Month",
    options = [], 
    size = "small",
    isRequired,
    disabled,
    description,
  } = props;

  const [selectedValue, setSelectedValue] = useState(value);

  const handleChange = (event) => {
    const selected = event.target.value;
    setSelectedValue(selected);
    onChange(selected);
  };

  return (
    <MonthYearPickerStyled>
      {label && (
        <Typography className="label">
          {label}
          {isRequired && "*"}
          {description && <InfoIcon message={description} />}
        </Typography>
      )}

      <div className="picker-wrapper">
        <div className="custom-select" role="button">
          <Select
            value={selectedValue !== null ? selectedValue : ""}
            onChange={handleChange}
            displayEmpty
            disabled={disabled}
            className="picker-select"
            variant="standard"
            MenuProps={{ disableScrollLock: true }}
          >
            <MenuItem value="" disabled>
              {placeholder}
            </MenuItem>
            {options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </div>
      </div>
    </MonthYearPickerStyled>
  );
};

MonthPickerField.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  options: PropTypes.array, // Add prop type for options
  size: PropTypes.string,
  isRequired: PropTypes.bool,
  disabled: PropTypes.bool,
  description: PropTypes.string,
};


export default React.memo(MonthPickerField);
